import { render, staticRenderFns } from "./AddessMobileForm.vue?vue&type=template&id=bad4c204&scoped=true&"
import script from "./AddessMobileForm.vue?vue&type=script&lang=js&"
export * from "./AddessMobileForm.vue?vue&type=script&lang=js&"
import style0 from "./AddessMobileForm.vue?vue&type=style&index=0&id=bad4c204&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad4c204",
  null
  
)

export default component.exports